import React, { useState } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import './index.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [encSalt, setEncSalt] = useState(null);
  const [masterPassword, setMasterPassword] = useState(null);

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-white transition-colors">
      {isAuthenticated ? (
        <Dashboard encSalt={encSalt} masterPassword={masterPassword} setIsAuthenticated={setIsAuthenticated} />
      ) : (
        <Login setIsAuthenticated={setIsAuthenticated} setEncSalt={setEncSalt} setMasterPassword={setMasterPassword} />
      )}
    </div>
  );
}

export default App;